import { HelpTextMarkdown } from '@diagentech/exprworks-ui-components';
import React from 'react';

import { withAboutUsText, WithAboutUsTextProps } from '@/components/aboutUs/withAboutUsText';

interface AboutUsContentProps extends WithAboutUsTextProps {}

export const AboutUsContentComponent: React.FC<AboutUsContentProps> = ({ text }) => {
  return <HelpTextMarkdown id={'about-us'} text={text} />;
};

export const AboutUsContent = withAboutUsText(AboutUsContentComponent);
